/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from '../mockServer/featureMock';
import {
    CashRegistersListDto,
    CashRegisterDto,
    InitOtpResponseDto,
    CashRegisterStatusHistoryPage,
} from './cashRegistersClient.typings';
import {
    cashRegisterListDtoFactory,
    cashRegisterDtoFactory,
    initOtpResponseDtoFactory,
    cashRegisterStatusHistoryDtoFactory,
} from './cashRegistersFactories';

const CASH_REGISTERS_URL = /\/cashRegisters$/;
const STATUS_HISTORY_URL = /\/cashRegisters\/(.+)\/statuses$/;
const INIT_OTP_URL = /\/cashRegisters\/(.+)\/init\/otp$/;
const CASH_REGISTER_URL = /\/cashRegisters\/(.+)$/;

class CashRegistersFeatureMock extends BaseFeatureMock {
    public readonly list = this.route<CashRegistersListDto>({
        method: 'get',
        url: CASH_REGISTERS_URL,
        defaultResponse: (config) => {
            const data: CashRegistersListDto = {
                count: config.params.limit * 3,
                cashRegisters: cashRegisterListDtoFactory.list({
                    count: config.params.limit,
                }),
            };
            return [200, data];
        },
        delayMs: () => Math.random() * 100,
    });

    public readonly statusHistory = this.route<CashRegisterStatusHistoryPage>({
        method: 'get',
        url: STATUS_HISTORY_URL,
        defaultResponse: (config) => {
            const data: CashRegisterStatusHistoryPage = {
                count: config.params.limit * 3,
                statuses: cashRegisterStatusHistoryDtoFactory.list({ count: config.params.limit }),
            };
            return [200, data];
        },
        delayMs: 300,
    });

    public readonly createInitOtp = this.route<InitOtpResponseDto>({
        method: 'post',
        url: INIT_OTP_URL,
        defaultResponse: () => {
            const data: InitOtpResponseDto = initOtpResponseDtoFactory.item();
            initOtpResponseDtoFactory.resetCount();
            return [200, data];
        },
        delayMs: () => Math.random() * 400,
    });

    public readonly details = this.route<CashRegisterDto>({
        method: 'get',
        url: CASH_REGISTER_URL,
        defaultResponse: () => {
            const data: CashRegisterDto = cashRegisterDtoFactory.item();
            return [200, data];
        },
        delayMs: () => Math.random() * 500,
    });

    protected onReset(): void {
        cashRegisterListDtoFactory.resetCount();
        cashRegisterDtoFactory.resetCount();
        initOtpResponseDtoFactory.resetCount();
        cashRegisterStatusHistoryDtoFactory.resetCount();
    }
}

export const cashRegistersMock = new CashRegistersFeatureMock();

/** Backward-compat shim - dev mock mode (mockAdapter.ts) keeps calling this untouched. */
export function addCashRegistersMockApi(mockAdapter: MockAdapter): void {
    cashRegistersMock.register(mockAdapter, { delay: true });
}
